import { OWListener, OWListenerDelegate } from './common';
import {
  AppInstallationEvent,
  AppLaunchTriggeredEvent,
  ExtensionUpdatedEvent,
} from './type-aliases';

// -----------------------------------------------------------------------------
export interface OWExtensionsDelegate extends OWListenerDelegate {
  onAppLaunchTriggered?(event: AppLaunchTriggeredEvent);
  onAppInstalled?(event: AppInstallationEvent);
  onAppUninstalled?(event: AppInstallationEvent);
  onExtensionUpdated?(event: ExtensionUpdatedEvent);
}

// -----------------------------------------------------------------------------
export class OWExtensionsListener extends OWListener<OWExtensionsDelegate> {
  // ---------------------------------------------------------------------------
  constructor(delegate: OWExtensionsDelegate, autoStart = false) {
    super(delegate);

    if (autoStart) {
      this.start();
    }
  }

  // ---------------------------------------------------------------------------
  public start(): void {
    // This calls |stop|
    super.start();

    if (this._delegate.onAppLaunchTriggered) {
      overwolf.extensions.onAppLaunchTriggered.addListener(
        this.onAppLaunchTriggered,
      );
    }

    if (this._delegate.onAppInstalled) {
      overwolf.extensions.onAppInstalled.addListener(this.onAppInstalled);
    }

    if (this._delegate.onAppUninstalled) {
      overwolf.extensions.onAppUninstalled.addListener(this.onAppUninstalled);
    }

    if (this._delegate.onExtensionUpdated) {
      overwolf.extensions.onExtensionUpdated.addListener(
        this.onExtensionUpdated,
      );
    }
  }

  // ---------------------------------------------------------------------------
  public stop(): void {
    overwolf.extensions.onAppLaunchTriggered.removeListener(
      this.onAppLaunchTriggered,
    );

    overwolf.extensions.onAppInstalled.removeListener(this.onAppInstalled);

    overwolf.extensions.onAppUninstalled.removeListener(this.onAppUninstalled);

    overwolf.extensions.onExtensionUpdated.addListener(this.onExtensionUpdated);
  }

  // ---------------------------------------------------------------------------
  private onAppLaunchTriggered = (event: AppLaunchTriggeredEvent): void => {
    if (!this._delegate.onAppLaunchTriggered) {
      return;
    }

    this._delegate.onAppLaunchTriggered(event);
  };

  // ---------------------------------------------------------------------------
  private onAppInstalled = (event: AppInstallationEvent): void => {
    if (!this._delegate.onAppInstalled) {
      return;
    }

    this._delegate.onAppInstalled(event);
  };

  // ---------------------------------------------------------------------------
  private onAppUninstalled = (event: AppInstallationEvent): void => {
    if (!this._delegate.onAppUninstalled) {
      return;
    }

    this._delegate.onAppUninstalled(event);
  };

  // ---------------------------------------------------------------------------
  private onExtensionUpdated = (event: ExtensionUpdatedEvent): void => {
    if (!this._delegate.onExtensionUpdated) {
      return;
    }

    this._delegate.onExtensionUpdated(event);
  };
}
